import {CsColorHelper} from "../../scripts/utils/cs-color-helper";
import {CsBaseComponent} from "../cs-base-component/cs-base-component";

// @ts-ignore
import template from './cs-button.html';

class CsButton extends CsBaseComponent {
    static acceptedAttributes = ['open', 'backgroundColor', 'text', 'target'];

    static get observedAttributes() {
        return this.acceptedAttributes;
    }

    getTemplate(): string {
        return template;
    }

    applyStyles() {
        const backgroundColor = this.getAttribute('backgroundColor') || 'inherit';
        const textColor = CsColorHelper.getTextColorForBackground(backgroundColor);
        const button: HTMLElement | null = this.querySelector(`#${this.elementId}`);

        if (button) {
            button.style.background = backgroundColor;
            button.style.color = textColor;
        }
    }

    addEventListeners() {
        this.addEventListener('click', () => {
            const navigateUrl = this.getAttribute('open');
            if (navigateUrl) this.navigateByUrl(navigateUrl);
        });
    }

    navigateByUrl(url: string) {
        const target = this.getAttribute('target') || '_self';

        if (target === '_self') {
            window.location.href = url;
        } else {
            window.open(url, target);
        }
    }
}

customElements.define('cs-button', CsButton);
